import _ from 'lodash'
import notificationCampaignApi from '@/api/notification-campaign'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultFilters = () => ({
  pageNumber: 1,
  pageSize: 25,
  status: null,
})

const state = {
  campaignId: null,
  campaign: null,

  list: [],
  totalCount: 0,
  loading: false,
  filters: getDefaultFilters(),
}

const getters = {}

const actions = {
  open({ commit, dispatch }, id) {
    commit('OPENED', id)

    return Promise.all([dispatch('fetchCampaign'), dispatch('fetchList')])
  },
  fetchCampaign({ commit }) {
    return notificationCampaignApi.getById(state.campaignId)
      .then(({ data }) => commit('SET_CAMPAIGN', data))
      .catch(() => store.dispatch('message/error', 'Не удалось открыть рассылку'))
  },
  fetchList({ commit }) {
    commit('LIST_LOADING')

    return notificationCampaignApi.getRecipients(state.campaignId, { ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
      .catch(() => commit('SET_LIST', { items: [], metadata: { totalItemCount: 0 } }))
  },
}

const mutations = {
  OPENED(state, id) {
    state.campaignId = id
    state.campaign = null
    state.list = []
    state.totalCount = 0
    Object.assign(state.filters, getDefaultFilters())
  },
  SET_CAMPAIGN(state, data) {
    state.campaign = data
  },
  LIST_LOADING(state) {
    state.loading = true
  },
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  ...generateFormHandlerMutations(state),
}

const watchers = [
  [
    state => state.notificationCampaign.recipients.filters.status,
    () => store.commit('notificationCampaign/recipients/FORM_UPDATE_FIELD', { key: 'filters.pageNumber', value: 1 }),
  ],
  [
    state => state.notificationCampaign.recipients.filters,
    _.debounce(async () => await store.dispatch('notificationCampaign/recipients/fetchList'), 250),
    { immediate: false, deep: true },
  ],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  watchers,
}
